import { useBusinessContext } from '@root/context'
import { useQuery } from '@tanstack/react-query'
import { fetchInvoicingBankAccounts } from '../invoicingBankAccounts'

interface UseInvoicingBankAccountsOptions {
  enabled?: boolean
}

export const useInvoicingBankAccounts = ({
  enabled = true
}: UseInvoicingBankAccountsOptions = {}) => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'invoicing-bank-accounts'],
    queryFn: () => fetchInvoicingBankAccounts({ slug }),
    enabled: Boolean(slug) && enabled
  })
}
